<template>
  <div>
    <div v-if="isAddOpened"
         class="add-box"
    >
      <label v-help.mouse="`0 = bez omezeni`">Max počet prohlédnutí</label>
      <input v-model="add.uses_limit"
             type="number"
             min="0"
      />
      <label>Platnost od</label>
      <input v-model="add.from"
             type="datetime-local"
      />
      <label>Platnost do</label>
      <input v-model="add.to"
             type="datetime-local"
      />
      <ActiveButton class="asd-btn-confirm"
                    :click="addEntry"
      >
        <i class="fas fa-plus"></i>
      </ActiveButton>
    </div>
    <table v-if="loaded"
           class="asd-table"
    >
      <thead>
        <tr class="table-heading">
          <th>
            <button class="asd-btn-confirm asd-btn-single-icon"
                    @click="isAddOpened = true"
            >
              <i class="fas fa-plus"></i>
            </button>
          </th>
          <th>Platnost od</th>
          <th>Platnost do</th>
          <th>Autor</th>
          <th>Počet prohlédnutí</th>
          <th>Max počet prohlédnutí</th>
          <th>Odkaz</th>
        </tr>
      </thead>

      <tbody>
        <tr v-for="row in entries"
            :key="row.entity_id"
        >
          <td>
            <ActiveButton
              v-help.mouse="`Smazat PA`"
              class="asd-btn-delete"
              :click="deleteEntry"
              :confirmText="`Opravdu chcete smazat tuto polozku?`"
              :fncParam="row"
            >
              <i class="fas fa-trash"></i>
            </ActiveButton>
          </td>
          <td>{{ row.from }}</td>
          <td>{{ row.to }}</td>
          <td>{{ row.creatorUsername }}</td>
          <td>{{ row.uses_count }}x</td>
          <td>{{ row.uses_limit }}</td>
          <td><a :href="row.link">Veřejný odkaz</a></td>
        </tr>
      </tbody>
    </table>
    <Spinner v-else></Spinner>
  </div>
</template>

<script>
import { map, get } from 'lodash'
import Spinner from 'CORE/components/utilities/spinner'
import EventBus from 'CORE/bus'
import axios from 'axios'
import ActiveButton from 'CORE/components/form/active-button'
import moment from 'moment'

const createDefaultAddData = () => {
    return {
        from: moment().toISOString(true).substr(0, 19),
        to: moment().add(1, 'weeks').toISOString(true).substr(0, 19),
        uses_limit: 0,
    }
}

export default {
    name: 'PublicViewList',
    components: {
        Spinner,
        ActiveButton,
    },

    props: {
        entity: {
            type: String,
            required: true,
            default: () => null,
        },
    },
    data() {
        return {
            entries: [],
            loaded: false,
            isAddOpened: false,
            add: {
                from: null,
                to: null,
                uses_limit: 0,
            },
        }
    },
    async mounted() {
        this.loadData()
        this.add = createDefaultAddData()
        console.info(this.add)
    },
    methods: {
        async loadData() {
            this.loaded = false
            try {
                const entries = get(await axios.get(`/workflow/public-access/list/${this.entity}`), 'data.data', [])
                this.entries = map(entries, e => {
                    const from = get(e.validity, 'lower')
                    const to = get(e.validity, 'upper')
                    const usesLimit = get(e, 'uses_limit')
                    return {
                        id: e.id_public_access,
                        creatorUsername: get(this.$store.getters.userById(e.user_id), 'username'),
                        from: from === null ? 'Bez limitu' : from,
                        to: to === null ? 'Bez limitu' : to,
                        uses_count: get(e, 'uses_count', 0),
                        uses_limit: usesLimit === null ? 'Bez limitu' : usesLimit,
                        link: `/workflow/public-access/view/${e.id_public_access}`,
                    }
                })
            } catch (e) {
                EventBus.$emit('FLASH_USER_ERROR', { message: e })
            } finally {
                this.loaded = true
            }
        },
        async deleteEntry(entry) {
            await axios.delete(`/workflow/public-access/delete/${entry.id}`)
            await this.loadData()
        },
        async addEntry() {
            console.info(this.add)
            await axios.post(`/workflow/public-access/add/${this.entity}`, {
                uses_limit: this.add.uses_limit,
                validity: { lower: this.add.from, upper: this.add.to },
            })
            await this.loadData()
        },
    },
}
</script>

<style lang="scss" scoped>
.add-box {
    margin: 10px;
}
</style>
